import { Component } from 'react'
import styled from 'glamorous'
// import moment from 'moment'
import { map } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { withRouter } from 'react-router-dom'
import { compose, graphql } from 'react-apollo'

import { client } from 'config'
import { $, getLocationQuery, getUrlSearch, getError } from 'utils'
import { withConsumer } from 'store'
import { Button, Icon, InfoRow, Loader, HeaderRow, EditableName, Tooltip, ImagePure } from 'components'
import { AddPersonsPanel, AddFacesPanel } from 'components/panels'
import {
  LIST, PERSON_LISTS, DESCRIPTOR_LISTS, UpdateListMutation,
  DeleteListMutation, AttachDescriptorToList, AttachPersonToList,
  DetachDescriptorFromList, DetachPersonFromList
} from 'queries'
import { getVariables } from './index'

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
})

const DetailsInfoContainer = styled(PerfectScrollbar)({
  position: 'relative',
}, 'scrollableContainer')

const InfoBlock = styled.div({
  padding: 30,
  borderBottom: '1px solid var(--borderColor)',
})

const PersonsBlock = styled.div({
  padding: 30,
})

const PhotoContainer = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
})

const Photo = styled.div({
  marginRight: 10,
  marginBottom: 10,
  '&:nth-child(3n)': {
    marginRight: 0,
  },
})

const BottomBar = styled.div({
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 20,
})

// const date = moment().format('DD MMMM YYYY | HH:mm:ss')

export class DetailsPage extends Component {

  state = {
    addMode: undefined
  }

  componentWillMount() {
    this.setState({ offset: this.props.data.variables.offset })
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.data.list || this.props.data.list.uuid !== nextProps.data.list.uuid) {
      this.setState({ bottomView: undefined, addMode: undefined })
    }
  }

  setAddMode = (mode) => this.setState({ addMode: mode })

  fetchMore = () => {
    const target = this.props.type === 'persons' ? 'persons' : 'descriptors'
    this.setState({ offset: this.state.offset + 1 }, () =>
      this.props.data.fetchMore({
        variables: {
          offset: this.state.offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newItems = [...prev.list[target], ...fetchMoreResult.list[target]]
          return {...prev, list: { ...prev.list, [target]: newItems }}
        }
      })
    )
  }

  updateListData = (value) => {
    const { updateList } = this.props
    return updateList({
      variables: {
        uuid: this.props.data.list.uuid,
        listData: value,
      },
      update: (proxy, { data: { updateList } }) => {
        if (updateList.ok) {
          const variables = {
            uuid: this.props.data.list.uuid,
            ...listVariables
          }
          const data = proxy.readQuery({ query: LIST, variables })
          data.list.listData = value
          proxy.writeQuery({ query: LIST, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  getUpdatedVariables = () => {
    const query = this.props.type === 'persons' ? PERSON_LISTS : DESCRIPTOR_LISTS
    const list = this.props.type === 'persons' ? 'personsLists' : 'descriptorsLists'
    let variables = getVariables(getLocationQuery(this.props.location))
    const cacheData = client.cache.readQuery({ query, variables })
    if ((cacheData[list].count - 1) % variables.limit === 0) {
      if (cacheData[list].count === 1) {
        variables = getVariables()
      } else {
        variables.offset -= 1
      }
    }
    return variables
  }

  deleteList = () => {
    const variables = this.getUpdatedVariables()
    return this.props.deleteList({
      variables: { uuid: this.props.data.list.uuid },
      refetchQueries: [{
        query: this.props.type === 'persons' ? PERSON_LISTS : DESCRIPTOR_LISTS,
        variables
      }]
    }).then((response) => {
      if (response.data.deleteList.ok) {
        const variables = this.getUpdatedVariables()
        this.props.history.push({
          pathname: `/list/${this.props.type}`,
          search: getUrlSearch(variables),
        })
      }
    }).catch(error => this.props.setErrorMessage(getError(error)))
  }

  detachDescriptorFromList = (items, needRefetch) => {
    this.setState({ offset: 1 })
    return this.props.detachDescriptorFromList({
      variables: {
        descriptorUUIDs: map(items, item => item.uuid),
        listUUID: this.props.data.list.uuid,
      },
      ...needRefetch && {
        refetchQueries: [{
          query: LIST,
          variables: {
            uuid: this.props.data.list.uuid,
            ...listVariables
          }
        }]
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  attachDescriptorToList = (items) => {
    this.setState({ offset: 1 })
    return this.props.attachDescriptorToList({
      variables: {
        descriptorUUIDs: map(items, item => item.uuid),
        listUUID: this.props.data.list.uuid,
      },
      refetchQueries: [{
        query: LIST,
        variables: {
          uuid: this.props.data.list.uuid,
          ...listVariables
        }
      }]
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  handleSubmitDescriptors = async (detach, attach) => {
    if (detach.length > 0) {
      await this.detachDescriptorFromList(detach, attach.length === 0)
    }
    if (attach.length > 0) {
      this.attachDescriptorToList(attach)
    }
  }


  detachPersonFromList = (items, needRefetch) => {
    this.setState({ offset: 1 })
    return this.props.detachPersonFromList({
      variables: {
        personUUIDs: map(items, item => item.uuid),
        listUUID: this.props.data.list.uuid,
      },
      ...needRefetch && {
        refetchQueries: [{
          query: LIST,
          variables: {
            uuid: this.props.data.list.uuid,
            ...listVariables
          }
        }]
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  attachPersonToList = (items) => {
    this.setState({ offset: 1 })
    return this.props.attachPersonToList({
      variables: {
        personUUIDs: map(items, item => item.uuid),
        listUUID: this.props.data.list.uuid,
      },
      refetchQueries: [{
        query: LIST,
        variables: {
          uuid: this.props.data.list.uuid,
          ...listVariables
        }
      }]
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  handleSubmitPersons = async (detach, attach) => {
    if (detach.length > 0) {
      await this.detachPersonFromList(detach, attach.length === 0)
    }
    if (attach.length > 0) {
      this.attachPersonToList(attach)
    }
  }

  render() {
    const { data: { list, loading }, type, history } = this.props
    const { addMode } = this.state
    if (loading && !list) return $(Loader)

    const { uuid, persons, descriptors, listData, count } = list
    const items = type === 'persons' ? persons || [] : descriptors || []

    return (
      $(Container,
        $(DetailsInfoContainer,
          $(InfoBlock,
            $(HeaderRow, { label: $(EditableName, { key: uuid, value: listData, onUpdate: this.updateListData }) },
              $(Tooltip, { tip: 'Delete list' },
                $(Icon, {
                  type: 'delete',
                  onClick: this.deleteList
                })
              )
            ),
            $(InfoRow, { name: 'ID:', value: uuid, }),
            // $(InfoRow, { name: 'Create time:', value: `${date} (fake)` }),
            // $(InfoRow, { name: 'Last update:', value: `${date} (fake)` }),
          ),
          $(PersonsBlock,
            $(HeaderRow, { label: type === 'persons' ? 'Persons' : 'Faces', count },
              $(Tooltip, { tip: `Add ${type === 'persons' ? 'persons' : 'faces'}` },
                $(Icon, { type: 'add', onClick: () => this.setAddMode(type) })
              )
            ),
            $(PhotoContainer,
              map(items, (val, key) =>
                $(Photo, {
                  key,
                  onClick: () => history.push({ pathname: `/${type}/${val.uuid}` })
                },
                  $(ImagePure, {
                    src: val.portrait,
                    width: 100,
                    height: 130,
                    isHoverable: true
                  })
                )
              )
            ),
            items.length > 0 && items.length < count &&
            $(BottomBar,
              $(Button, {
                onClick: this.fetchMore,
                bgColor: '#9a9af2',
                primary: true,
                width: '185px',
              }, 'Show more'),
            )
          ),
        ),
        addMode === 'faces' && $(AddFacesPanel, {
          syncMode: true,
          targetType: 'list',
          targetId: uuid,
          onSubmit: this.handleSubmitDescriptors,
          onClose: () => this.setAddMode(),
        }),
        addMode === 'persons' && $(AddPersonsPanel, {
          syncMode: true,
          targetType: 'list',
          targetId: uuid,
          onSubmit: this.handleSubmitPersons,
          onClose: () => this.setAddMode(),
        }),
      )
    )
  }
}

export default withRouter(
  compose(
    graphql(UpdateListMutation, {name: 'updateList'}),
    graphql(DeleteListMutation, {name: 'deleteList'}),
    graphql(AttachDescriptorToList, {name: 'attachDescriptorToList'}),
    graphql(DetachDescriptorFromList, {name: 'detachDescriptorFromList'}),
    graphql(AttachPersonToList, {name: 'attachPersonToList'}),
    graphql(DetachPersonFromList, {name: 'detachPersonFromList'}),
    graphql(LIST, {
      options: props => ({
        fetchPolicy: 'cache-and-network',
        variables: {
          uuid: props.match.params.id,
          ...listVariables
        }
      })
    })
  )(withConsumer(DetailsPage, window.location.pathname.indexOf('persons') !== -1 ? '/list/persons' : '/list/faces')))

const listVariables = {
  offset: 1,
  limit: 9
}



// WEBPACK FOOTER //
// ./src/pages/Lists/DetailsPage.js